// Mirrors backend/src/config/permissions.js (workspace-role enum + isSuperAdmin
// staff flag). The frontend trusts the API-provided `permissions` array — it
// never derives permissions from roles — so the two stay in sync.

export type WorkspaceRole = 'owner' | 'admin' | 'finance' | 'content' | 'media' | 'viewer';

export type PermissionKey =
  | 'workspace:read' | 'workspace:update' | 'workspace:delete'
  | 'members:read' | 'members:invite' | 'members:update_role' | 'members:remove'
  | 'billing:read' | 'billing:manage'
  | 'campaign:read' | 'campaign:create' | 'campaign:update' | 'campaign:delete' | 'campaign:launch' | 'campaign:trigger'
  | 'content:generate' | 'content:generate_visual'
  | 'templates:read' | 'templates:manage'
  | 'contacts:read' | 'contacts:manage'
  | 'uploads:create'
  | 'analytics:read'
  | 'support:read' | 'support:create' | 'support:manage';

// True if the permission list satisfies the key ('*' = super-admin wildcard).
export function can(permissions: string[] | undefined | null, key: PermissionKey): boolean {
  return !!permissions && (permissions.includes('*') || permissions.includes(key));
}
